import type { FaireProductEntity } from "../../entity_types/product";

export const p_y3qwdbqxpg: FaireProductEntity = {
  token: "p_y3qwdbqxpg",
  type: "product",
  name: "( F246 )  BOW KNOT EARRING",
  brandToken: "b_r5aqp735w9",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/84d6c0ed335004c0105e782139a57dfcf1e1758b7decfdf866a14e0906d67255.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.99,
  description: "The Bow Knot Earring from Jewelry Max is a beautifully crafted piece that is both elegant and stylish. Measuring at 1 x 1 1/4 inches, this dangle earring is a standout addition to any jewelry collection. Its design, resembling a delicate bow knot, adds a touch of sophistication to any outfit. Explore our stunning collection and elevate your style with Jewelry Max.",
  tags: [],
  msrpDollars: 13.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:55.055Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
